import { Component } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Catches render errors on a page so one broken screen doesn't take the whole app down. Resets when `resetKey` changes. */
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  componentDidCatch(error, info) {
     
    console.error("Page crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto flex max-w-lg flex-col items-center gap-3 px-4 py-16 text-center" data-testid="page-error">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-red-50 text-red-600"><AlertTriangle className="h-6 w-6" /></div>
        <h1 className="page-title text-xl">This page hit an error</h1>
        <p className="text-sm text-muted-foreground">{String(this.state.error?.message || this.state.error)}</p>
        <Button variant="outline" onClick={() => this.setState({ error: null })}>Try again</Button>
      </div>
    );
  }
}
